export function createInitialEntities<TId extends string, TEntity>(
  ids: readonly TId[],
  factory: (id: TId) => TEntity,
): Record<TId, TEntity> {
  return ids.reduce(
    (acc, id) => {
      acc[id] = factory(id);
      return acc;
    },
    {} as Record<TId, TEntity>,
  );
}
